import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListCategoryFAQElement } from '../types/apiGeneratedTypes';

export interface AppPageState {
  faqList: ListCategoryFAQElement[] | null;
  faqDataToEdit: any | null;
  isUpdateFAQModalOpened: boolean;
  isDeleteFAQModalOpened: boolean;
  isConfirmFAQModalOpened: boolean;
  faqTableKey: number;
}

export const initialState: AppPageState = {
  faqList: null,
  faqDataToEdit: null,
  isUpdateFAQModalOpened: false,
  isDeleteFAQModalOpened: false,
  isConfirmFAQModalOpened: false,
  faqTableKey: 0,
};

const clinicsPageSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setFAQList(state, action: PayloadAction<ListCategoryFAQElement[] | null>) {
      state.faqList = action.payload;
    },
    setFAQDataToEdit(state, action: PayloadAction<any | null>) {
      state.faqDataToEdit = action.payload;
    },
    changeUpdateFAQModalVisibility(state, action: PayloadAction<boolean>) {
      state.isUpdateFAQModalOpened = action.payload;
    },
    changeDeleteFAQModalVisibility(state, action: PayloadAction<boolean>) {
      state.isDeleteFAQModalOpened = action.payload;
    },
    changeConfirmFAQModalVisibility(state, action: PayloadAction<boolean>) {
      state.isConfirmFAQModalOpened = action.payload;
    },
    setFAQTableKey(state, action: PayloadAction<number>) {
      state.faqTableKey = action.payload;
    },
  },
});

export const {
  setFAQList,
  setFAQDataToEdit,
  changeUpdateFAQModalVisibility,
  setFAQTableKey,
  changeDeleteFAQModalVisibility,
  changeConfirmFAQModalVisibility,
} = clinicsPageSlice.actions;
export default clinicsPageSlice.reducer;
